const TYPE_MAPPER_CHARTS = ["tm_status", "tm_monthly_status", "tm_latest_items", "download_items"];

const TOP10_CHART = "top-compared-items";
const VS_SALES = "vs-sales";
const VS_AVERAGE_ORDER_VALUE = "vs-average-order-value";

const ITEM_COVERAGE_STATUSES = [
  {
    name: "successfully-parsed",
    title: "charts.itemCoverageChart.successfullyParsed",
    backgroundColor: "#16C6B9",
    border: "solid 1px #11988E",
    type: "is-inverse-primary",
  },
  {
    name: "vs-optimization-in-progress",
    title: "charts.itemCoverageChart.vsOptimizationInProgress",
    backgroundColor: "#33A3FF",
    border: "solid 1px #0070CC",
    type: "is-in-progress",
  },
  {
    name: "missing-measurements",
    title: "charts.itemCoverageChart.missingMeasurements",
    backgroundColor: "#F4628E",
    border: "solid 1px #CC5353",
    type: "is-inverse-error-1",
  },
  {
    name: "no-measurements",
    title: "charts.itemCoverageChart.noMeasurements",
    backgroundColor: "#EC386E",
    border: "solid 1px #BF2E2E",
    type: "is-inverse-error-2",
  },
  {
    name: "unsupported-category",
    title: "charts.itemCoverageChart.unsupportedCategory",
    backgroundColor: "#737373",
    border: "solid 1px #575757",
    type: "is-inverse-gray",
  },
];

const USAGE_DEFINITION = [
  {
    name: "recommendations",
    rateTitle: "charts.usagePageCharts.recommendationRate",
    valueTitle: "charts.usagePageCharts.recommendations",
    rateChartName: "vs-recommendation-rate",
    valueChartName: "vs-recommendations",
    tooltip: "analyticsDefinitions.recommendationRate.definition",
  },
  {
    name: "clicks",
    rateTitle: "charts.usagePageCharts.CTR",
    valueTitle: "charts.usagePageCharts.clicks",
    rateChartName: "vs-click-rate",
    valueChartName: "vs-clicks",
    tooltip: "analyticsDefinitions.rateOfButtonClicks.definition",
  },
  {
    name: "comparisons",
    rateTitle: "charts.usagePageCharts.comparisonRate",
    valueTitle: "charts.usagePageCharts.comparison",
    rateChartName: "vs-comparison-rate",
    valueChartName: "vs-comparisons",
    tooltip: "analyticsDefinitions.compareRate.definition",
  },
];

const addUniqueToChartNames = (arr) =>
  arr.map((definition) => {
    return {
      ...definition,
      rateChartName: `unique-${definition.rateChartName}`,
      valueChartName: `unique-${definition.valueChartName}`,
    };
  });

const UNIQUE_USER_USAGE_DEFINITION = addUniqueToChartNames(USAGE_DEFINITION);

const PERFORMANCE_DEFINITION = [
  {
    name: "conversionRate",
    title: "performance.conversionRate.conversionRate",
    content: [
      {
        name: "sizeRecommendations",
        title: "performance.conversionRate.sizeRecommendations",
        content: "performance.conversionRate.sizeRecommendationsDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-recommendations-purchase-rate",
        valueChartName: "vs-purchase-recommendations",
      },
      {
        name: "clicks",
        title: "performance.conversionRate.clicks",
        content: "performance.conversionRate.clicksDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-clicks-purchase-rate",
        valueChartName: "vs-purchase-clicks",
      },
      {
        name: "comparisons",
        title: "performance.conversionRate.comparisons",
        content: "performance.conversionRate.comparisonsDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-comparisons-purchase-rate",
        valueChartName: "vs-purchase-comparisons",
      },
      {
        name: "withoutVirtusize",
        title: "performance.conversionRate.withoutVirtusize",
        content: "performance.conversionRate.withoutVirtusizeDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-without-purchase-rate",
        valueChartName: "vs-purchase-without",
      },
    ],
  },
  {
    name: "purchaseShare",
    title: "performance.purchaseShare.purchaseShare",
    content: [
      {
        name: "sizeRecommendations",
        title: "performance.purchaseShare.sizeRecommendations",
        content: "performance.purchaseShare.sizeRecommendationsDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-purchase-recommendations-share-rate",
        valueChartName: "vs-purchase-recommendations",
      },
      {
        name: "clicks",
        title: "performance.purchaseShare.clicks",
        content: "performance.purchaseShare.clicksDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-purchase-clicks-share-rate",
        valueChartName: "vs-purchase-clicks",
      },
      {
        name: "comparisons",
        title: "performance.purchaseShare.comparisons",
        content: "performance.purchaseShare.comparisonsDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-purchase-comparisons-share-rate",
        valueChartName: "vs-purchase-comparisons",
      },
      {
        name: "withoutVirtusize",
        title: "performance.purchaseShare.withoutVirtusize",
        content: "performance.purchaseShare.withoutVirtusizeDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-purchase-without-share-rate",
        valueChartName: "vs-purchase-without",
      },
    ],
  },
  {
    name: "saleShare",
    title: "performance.saleShare.saleShare",
    content: [
      {
        name: "sizeRecommendations",
        title: "performance.saleShare.sizeRecommendations",
        content: "performance.saleShare.sizeRecommendationsDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-sales-recommendations-share-rate",
        valueChartName: "vs-sales-recommendations",
      },
      {
        name: "clicks",
        title: "performance.saleShare.clicks",
        content: "performance.saleShare.clicksDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-sales-clicks-share-rate",
        valueChartName: "vs-sales-clicks",
      },
      {
        name: "comparisons",
        title: "performance.saleShare.comparisons",
        content: "performance.saleShare.comparisonsDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-sales-comparisons-share-rate",
        valueChartName: "vs-sales-comparisons",
      },
      {
        name: "withoutVirtusize",
        title: "performance.saleShare.withoutVirtusize",
        content: "performance.saleShare.withoutVirtusizeDef",
        rateTitle: "performance.rate",
        valueTitle: "performance.total",
        rateChartName: "vs-sales-without-share-rate",
        valueChartName: "vs-sales-without",
      },
    ],
  },
];

const UNIQUE_USER_PERFORMANCE_DEFINITION = PERFORMANCE_DEFINITION.map((view) => {
  return {
    ...view,
    content: view.name === "saleShare" ? view.content : addUniqueToChartNames(view.content),
  };
});

const CHART_DEFINITION = [
  {
    name: "unique-vs-users",
    title: "charts.users",
    type: "lineChart",
    gridWidth: "6",
    totalFormat: "0,0",
    callAPIWithMonthParam: true,
    tooltip: "analyticsDefinitions.virtusizeUsers.definition",
  },
  {
    name: "vs-sales",
    title: "charts.sales",
    type: "barChart",
    gridWidth: "6",
    totalFormat: "currency",
    tooltip: "analyticsDefinitions.sales.definition",
  },
  {
    name: "vs-comparisons",
    title: "charts.comparisons",
    type: "barChart",
    gridWidth: "6",
    totalFormat: "0,0",
    tooltip: "analyticsDefinitions.compareViews.definition",
  },
  {
    name: "vs-average-order-value",
    title: "charts.averageOrderValue",
    type: "lineChart",
    gridWidth: "6",
    totalFormat: "currency",
    tooltip: "analyticsDefinitions.averageOrderValue.definition",
  },
  {
    name: "top-compared-items",
    title: "charts.topComparedItems",
    gridWidth: "6",
    heightClass: "high-column",
    callAPIWithMonthParam: true,
    tooltip: "analyticsDefinitions.conversionRateOfUser.definition",
  },
  {
    name: "vs-coverage-rate",
    title: "charts.coverageRate",
    type: "lineChart",
    gridWidth: "6",
    totalFormat: "0.0%",
    heightClass: "high-column",
    logo: "coverage-rate",
    tooltip: "analyticsDefinitions.productCoverageRate.definition",
  },
  {
    name: "user-saw-product",
    title: "charts.userSawProduct",
    totalFormat: "0,0",
    logo: "page-views",
    tooltip: "analyticsDefinitions.itemPageViews.definition",
  },
  {
    name: "vs-views",
    totalFormat: "0,0",
  },
];

const dashboardChartNames = [
  "vs-sales",
  "unique-vs-users",
  "vs-comparisons",
  "vs-average-order-value",
  "top-compared-items",
  "vs-coverage-rate",
];

const coverageChartNames = ["vs-coverage-rate", "user-saw-product", "vs-views"];

const TM_PANEL_DEFINITION = {
  name: "tm_status",
  title: "charts.itemCoverageRate",
  totalFormat: "0.0%",
  tooltip: "analyticsDefinitions.productCoverageRate.definition",
};

const DASHBOARD_CHART_DEFINITION = CHART_DEFINITION.filter((chart) => dashboardChartNames.includes(chart.name));

const COVERAGE_CHART_DEFINITION = CHART_DEFINITION.filter((chart) => coverageChartNames.includes(chart.name));

export {
  DASHBOARD_CHART_DEFINITION,
  TYPE_MAPPER_CHARTS,
  TOP10_CHART,
  USAGE_DEFINITION,
  UNIQUE_USER_USAGE_DEFINITION,
  PERFORMANCE_DEFINITION,
  UNIQUE_USER_PERFORMANCE_DEFINITION,
  COVERAGE_CHART_DEFINITION,
  CHART_DEFINITION,
  ITEM_COVERAGE_STATUSES,
  VS_SALES,
  VS_AVERAGE_ORDER_VALUE,
  TM_PANEL_DEFINITION,
};
